import { createApiSlice } from "@common";
import {
  CRUD_TARGET_SEGMENT
} from "@routes";

const apiConfig = [
  {
    name: "addTargetSegment",
    method: "post",
    url: CRUD_TARGET_SEGMENT,
    stateKey: "message",
  },
  {
    name: "getTargetSegment",
    method: "get",
    url: CRUD_TARGET_SEGMENT,
    stateKey: "data",
  },
  {
    name: "updateTargetSegment",
    method: "put",
    url: CRUD_TARGET_SEGMENT,
    stateKey: "message",
  },
  {
    name: "deleteTargetSegment",
    method: "delete",
    url: CRUD_TARGET_SEGMENT,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    details: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "targetSegment",
  apiConfig,
  customReducers,
);
const targetSegmentSlice = slice;

export default targetSegmentSlice.reducer;

export const {
  addTargetSegment,
  getTargetSegment,
  updateTargetSegment,
  deleteTargetSegment,
} = thunks;

export const { rowSelect } = actions;
